const Messages = {
  initial: 'initial',
  start: 'start',
  noGlasses: 'noGlasses',
  tooClose: 'tooClose',
  tooFar: 'tooFar',
  tooTilted: 'tooTilted',
  headUp: 'headUp',
  headDown: 'headDown',
  headLeft: 'headLeft',
  headRight: 'headRight',
  openEyes: 'openEyes',
  holdStill: 'holdStill',
  scanning: 'scanning',
  analyzing: 'analyzing',
  completed: 'completed',
} as const

type Message = (typeof Messages)[keyof typeof Messages]

export const Measurement = { Messages }

export type MeasurementMessage = Message
